const DATA = [
  {
    id: 0,
    name: "Быстрый суп с креветками",
    image: "https://www.gastronom.ru/binfiles/images/20220224/b9550746.jpg",
    steps: [
      {
        step: "Шаг 1",
        description:
          "Разморозьте креветки. Налейте в кастрюлю 2 ст. л. оливкового масла, всыпьте рис и обжаривайте, помешивая, 3 мин. Добавьте мелко нарезанный зеленый лук и карри, готовьте еще 2 мин. Влейте в кастрюлю кокосовое молоко, долейте 400 мл горячей воды и готовьте на среднем огне под крышкой 8 мин.",
      },
      {
        step: "Шаг 2",
        description:
          "Положите в суп размороженные креветки и продолжайте готовить еще 6 мин. Когда рис будет готов, посолите суп и приправьте перцем. Разлейте в тарелки и украсьте зеленым луком. Перед подачей сбрызните оливковым маслом.",
      },
    ],
    ingredients: [
      "250 г сырых замороженных креветок",
      "150 г риса",
      "2 ч. л. приправы карри",
      "8 перьев зеленого лука",
      "400 мл кокосового молока",
      "2 ст. л. оливкового масла",
      "соль",
      "свежемолотый черный перец",
    ],
  },
  {
    id: 1,
    name: "Грибной суп",
    image: "https://www.gastronom.ru/binfiles/images/20230809/ba810dd0.jpg",
    steps: [
      {
        step: "Шаг 1",
        description:
          "Поставьте воду на огонь, добавьте туда толстые стебли от петрушки и укропа, лавровый лист, пусть вода закипает. Шампиньоны сполосните и нарежьте слайсами. На сухой раскаленной сковороде вытопите из шампиньонов лишнюю влагу, долейте немного растительного масла и подрумяньте их до золотистого цвета.",
      },
      {
        step: "Шаг 2",
        description:
          "Добавьте в сковороду к шампиньонам замороженные белые грибы и постоянно помешивая, разморозьте их. А затем точно также вытопите лишнюю влагу. Добавьте еще немного масла и обжаривайте на среднем огне 5-7 минут. Из воды достаньте стебли зелени, лавровый лист и добавьте в кастрюлю грибную смесь.",
      },
      {
        step: "Шаг 3",
        description:
          "Лук очистите и нарежьте мелким кубиком, морковь измельчите на средней терке или нарежьте на удобные вам кусочки, чеснок пропустите через пресс. Спассеруйте овощи на той же сковороде, где были грибы — возможно понадобится долить еще немного масла. Готовые овощи добавьте в кастрюлю.",
      },
      {
        step: "Шаг 4",
        description:
          "Все тщательно перемешайте, посолите, поперчите и варите буквально 5 мин. После этого добавьте в суп лапшу и варите до готовности. При подаче добавьте измельченную зелень укропа и петрушки.",
      },
    ],
    ingredients: [
      "100 г замороженных белых грибов",
      "100 г шампиньонов",
      "1 небольшая репчатая луковица",
      "1 небольшая морковь",
      "2 зубчика чеснока",
      "1,5 литра питьевой воды",
      "30-40 г макаронных изделий из расчета на одну порцию",
      "3 веточки петрушки",
      "3 веточки укропа",
      "растительное масло",
      "лавровый лист",
      "соль",
      "свежемолотый черный перец",
    ],
  },
  {
    id: 2,
    name: "Легкая закуска с авокадо",
    image: "https://www.gastronom.ru/binfiles/images/20180211/b301b762.jpeg",
    steps: [
      {
        step: "Шаг 1",
        description:
          "Разрезать авокадо, удалить косточку, добавить вышеуказанные ингридиенты, по желанию заправить соком лайма.",
      },
    ],
    ingredients: [
      "авокадо 1-2 шт.",
      "томаты Черри 4-5 шт.",
      "редис 3-4 шт.",
      "гранат 1 ст.л.",
      "брынза 100 г",
      "розмарин щепотка(и)",
      "салат-корн",
      "мята шт.",
    ],
  },
  {
    id: 3,
    name: "Картофельный салат",
    image: "https://www.gastronom.ru/binfiles/images/20170221/b7823e5d.jpg",
    steps: [
      {
        step: "Шаг 1",
        description:
          "Приготовьте картофель для салата. Тщательно вымойте клубни щеткой и залейте горячей водой. Доведите до кипения и варите 20–30 минут до полной готовности. Дайте остыть.",
      },
      {
        step: "Шаг 2",
        description:
          "Приготовьте заправку салата. Чеснок очистите и пропустите через пресс. Залейте растительным маслом. Сок лайма тщательно перемешайте с сахаром и щепоткой соли. Соедините с масляной смесью и оставьте на 15 минут.",
      },
      {
        step: "Шаг 3",
        description:
          "Остывший картофель очистите и нарежьте крупными кубиками. Переложите в большую миску. Шампиньоны откиньте на дуршлаг и дайте стечь маринаду. Крупные грибы нарежьте.",
      },
      {
        step: "Шаг 4",
        description:
          "Свежие огурцы для салата вымойте и хорошо обсушите бумажным полотенцем. Срежьте кончики. Если кожура грубая, очистите ее. Огурцы нарежьте небольшими ломтиками или кубиками.",
      },
      {
        step: "Шаг 5",
        description:
          "Зеленый лук вымойте и обсушите бумажным полотенцем. Белую часть и нарежьте тонкими колечками. Зеленую часть стеблей лука нарежьте крупно и отложите для украшения салата.",
      },
      {
        step: "Шаг 6",
        description:
          "Ингредиенты салата, включая белую часть лука, соедините, посолите и поперчите. Перемешайте с заправкой. Выложите в салатник и украсьте крупно нарезанным зеленым луком.",
      },
    ],
    ingredients: [
      "клубни картофеля среднего размера – 3 шт.",
      "маринованные шампиньоны – 1 банка (250-300 г)",
      "свежие огурцы – 2 шт.",
      "зеленый лук – 5 стеблей",
      "соль, свежемолотый черный перец – по вкусу",
      "чеснок – 1 крупный зубчик",
      "растительное масло – 3 ст. л.",
      "сок 1/2 лайма",
      "коричневый сахар – 1/3 ч. л.",
      "соль – на кончике ножа",
    ],
  },
  {
    id: 4,
    name: "Брюссельская капуста с беконом",
    image: "https://www.gastronom.ru/binfiles/images/20150601/bbd6cf6b.jpg",
    steps: [
      {
        step: "Шаг 1",
        description:
          "Очистите от жестковатых внешних листьев кочанчики брюссельской капусты, вырежьте кочерыжки (они горчат). Отварите капусту до полуготовности в подсоленной кипящей воде, 4–5 мин.",
      },
      {
        step: "Шаг 2",
        description:
          "Порежьте бекон на тонкие ломтики. Разогрейте масло в глубокой сковородке и поджарьте на нем бекон до золотистого цвета. Добавьте капусту и обжарьте все вместе 2–3 мин.",
      },
      {
        step: "Шаг 3",
        description:
          "Посолите, сбрызните лимонным соком и перемешайте. Подавайте горячим.",
      },
    ],
    ingredients: [
      "400 г свежей брюссельской капусты",
      "100 г нежирного бекона",
      "2 ст. л. оливкового масла",
      "1 ст. л. лимонного сока",
      "соль",
    ],
  },
]

// https://www.gastronom.ru/recipe/21820/gribnoj-sup-pjure - в рекомендованное
// https://www.gastronom.ru/recipe/25523/prostye-farshirovannye-jajca

export const getNews = (offset, limit) => {
  // const result = [];
  // const result = DATA.filter((_, index) => (index >= offset && index <= limit))
  return DATA.filter((_, index) => (index >= offset && index < (limit + offset)))
}

export const findById = (id) => {
  return DATA.find((item) => item.id === id) || {}
}
